// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qx-0";